import { render, staticRenderFns } from "./capture-record.vue?vue&type=template&id=92a53cac&"
import script from "./capture-record.vue?vue&type=script&lang=js&"
export * from "./capture-record.vue?vue&type=script&lang=js&"
import style0 from "./capture-record.vue?vue&type=style&index=0&id=92a53cac&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports